export const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  const minutesString = minutes.toString().padStart(2, "0");
  const secsString = secs.toString().padStart(2, "0");

  return `${minutesString}:${secsString}`;
};
